import {useSportLogo} from "@/composables/useSportLogo";

export type Sport = 'HORSE_RACING' | 'SOCCER' | 'AMERICAN_FOOTBALL'
export type SportData = { value: Sport; label: string; icon: string; resourceId: string; iconSvg?: string }

const allSportOptions: SportData[] = [
	{value: 'SOCCER', label: 'Soccer', icon: '⚽', resourceId: 'soccer'},
	{value: 'HORSE_RACING', label: 'Horse Racing', icon: '🐎', resourceId: 'horse-racing'},
	{value: 'AMERICAN_FOOTBALL', label: 'American Football', icon: '🏈', resourceId: 'american-football'},
]

export async function useAllSports(): Promise<SportData[]> {
	const sports = Promise.all(
			allSportOptions.map(async (sport) => {
				return await useSport(sport.value);
			})
	);
	return sports;
}

export async function useSport(value: Sport): Promise<SportData> {
	const sport = allSportOptions.find(s => s.value === value);

	if (sport) {
		const svg = await useSportLogo({context: sport.resourceId, background: 'transparent'})
		return {
			...sport,
			iconSvg: svg
		}
	}

	const missingSportSvg = await useSportLogo({context: 'missing', background: 'transparent'})
	return {
		value: value,
		label: 'Missing ' + value,
		icon: '🚫',
		resourceId: 'missing',
		iconSvg: missingSportSvg
	}
}
